// fetchStatus check is required as this version of react query marks a query that is disabled as loading by default, whether or not it fetches
export function anyQueriesLoading(queries: { isLoading: boolean; fetchStatus: string }[]) {
  return queries.some(query => query.isLoading && query.fetchStatus !== 'idle')
}
